import { render, staticRenderFns } from "./MoveScene.vue?vue&type=template&id=567dc203&scoped=true"
import script from "./MoveScene.vue?vue&type=script&lang=js"
export * from "./MoveScene.vue?vue&type=script&lang=js"
import style0 from "./MoveScene.vue?vue&type=style&index=0&id=567dc203&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567dc203",
  null
  
)

export default component.exports